<h2 mat-dialog-title data-cy="TerminDetailsDialog">{{ termin?.betreff }}</h2>
<mat-dialog-content class="flex-container">
    <div class="flex-col gap-20" style="margin-top: 10px" data-cy="KalenderEditRow1">
        <div class="flex-1 flex-row gap-10">
            <div class="icon">
                <mat-icon>event</mat-icon>
            </div>

            <div class="blackText">
                {{ termin?.datum | date }}
                {{ (termin?.datum | date: 'HH:mm') != '00:00' ? ' ' + (termin?.datum | date: 'HH:mm') + ' Uhr' : '' }}
                {{ termin?.datum_bis && termin?.datum !== termin?.datum_bis ? ' - ' + (termin?.datum_bis | date) : '' }}
            </div>
        </div>

        @if (termin?.ort) {
            <div class="flex-1 flex-row gap-10">
                <div class="icon">
                    <mat-icon>place</mat-icon>
                </div>
                <div class="blackText">
                    {{ termin?.ort }}
                </div>
            </div>
        }

        @if (isLoggedIn || '' + termin!.id == tokenId) {
            @if (terminAnwesenheit.anmeldung_moeglich) {
                <div class="flex-1 flex-row gap-10" data-cy="TerminAnmeldeabschnitt">
                    <div class="icon">
                        <mat-icon>person</mat-icon>
                    </div>
                    <!-- <div class="blackText">
                        {{ termin?.beschreibung }}
                    </div> -->
                    <div class="blackText">
                        <div>
                            Teilnehmen:<br />
                            <mat-button-toggle-group
                                name="Kalenderansicht"
                                aria-label="Kalenderansicht"
                                [(ngModel)]="ownStatus"
                                data-cy="TerminAnmeldestatus">
                                <mat-button-toggle type="button" value="ja" (click)="setStatus('ja')"
                                    >Ja</mat-button-toggle
                                >
                                @if (termin?.anmeldungen_vielleicht) {
                                    <mat-button-toggle
                                        type="button"
                                        value="vielleicht"
                                        (click)="setStatus('vielleicht')">
                                        Vielleicht
                                    </mat-button-toggle>
                                }
                                <mat-button-toggle type="button" value="nein" (click)="setStatus('nein')"
                                    >Nein</mat-button-toggle
                                >
                            </mat-button-toggle-group>
                        </div>
                        <div style="padding-top: 10px; padding-bottom: 10px" data-cy="TerminBemerkungBereich">
                            @if (bemerkung) {
                                <mat-form-field class="flex-grow flexbase-100">
                                    <mat-label>Bemerkung</mat-label>
                                    <textarea
                                        matInput
                                        cdkTextareaAutosize
                                        #autosize="cdkTextareaAutosize"
                                        cdkAutosizeMinRows="2"
                                        placeholder=""
                                        [(ngModel)]="bemerkungText"
                                        data-cy="kalenderInhalt"></textarea>
                                </mat-form-field>
                                <button
                                    mat-raised-button
                                    (click)="setStatus(ownStatus, bemerkungText)"
                                    type="button"
                                    data-cy="TerminBemerkungSave">
                                    <mat-icon>done</mat-icon>
                                </button>
                                <button
                                    mat-raised-button
                                    (click)="bemerkung = false"
                                    type="button"
                                    data-cy="TerminBemerkungClose">
                                    <mat-icon>close</mat-icon>
                                </button>
                            } @else {
                                @if (ownStatus) {
                                    <a (click)="bemerkung = true" class="link">Bemerkung erstellen</a>
                                }
                            }
                        </div>

                        @if (isLoggedIn && termin?.anzeige_teilnehmer != 'keine') {
                            <div data-cy="TerminTeilnehmeranzahl">
                                <mat-icon>check_circle_outline</mat-icon>Ja: {{ terminJa }} <br />
                                @if (termin?.anmeldungen_vielleicht) {
                                    <mat-icon>remove_circle_outline</mat-icon>Vielleicht: {{ terminVielleicht }} <br />
                                }
                                <mat-icon>highlight_off</mat-icon>Nein: {{ terminNein }} <br />
                                <!-- <mat-icon>radio_button_unchecked</mat-icon>Keine Antwort: {{terminKeine}} <br> -->
                            </div>
                        }
                        @if (authService.hasRight('edit-anwesenheitsliste')) {
                            <button mat-button type="button" (click)="openListe()">An/Abmeldungen anzeigen</button>
                        }
                    </div>
                </div>
            }
<!-- 
            @if (termin?.anmeldungen && false) {
                <div class="flex-1 flex-row gap-10">
                    <div class="icon">
                        <mat-icon>groups</mat-icon>
                    </div>
                    <div class="blackText">Mitglieder, Vorstand, etc</div>
                </div>
            } -->
        }

        @if (termin && termin.beschreibung) {
            <div class="flex-1 flex-row gap-10">
                <div class="icon">
                    <mat-icon>notes</mat-icon>
                </div>
                <!-- <div class="blackText">
                    {{ termin?.beschreibung }}
                </div> -->
                <div class="blackText" [innerHTML]="termin.beschreibung | linky | nl2br"></div>
            </div>
        }
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" type="button" data-cy="closeBtn">Schließen</button>
</mat-dialog-actions>
